module.exports = __webpack_public_path__ + "static/media/roundaboutCCW270.ca1ea761.svg";